module.exports = __webpack_public_path__ + "img/icon-iso.867f6a93.svg";